import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_COMMUNICATION, UPDATE_COMMUNICATION } from './constants';
import {
  loadCommunicationSuccess,
  loadCommunicationError,
  updateCommunicationSuccess,
  updateCommunicationError,
} from './actions';

import history from 'utils/history';
import requestUtil from 'utils/request';
import requestWrapper from 'utils/requestWrapper';

// utils
import { endpoint } from 'utils/apis/axiosAPI';

export function* loadCommunicationSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const localActiveChild = yield JSON.parse(
      localStorage.getItem('schoolinked_child'),
    );
    const newKey = 'nouvel';
    const role = currentUser?.role;
    const prentID = currentUser?._id;
    const childID = localActiveChild?._id;
    const { ID, urlChildId } = action;

    const loadChildId = !!urlChildId ? urlChildId : childID;
    let itemDetailSaga = false;
    if (!!ID && ID != newKey && !!loadChildId) {
      // we get the campaigns linked to the communication
      itemDetailSaga = yield requestWrapper(
        'GET',
        endpoint?.parent?.communications?.single(ID, loadChildId),
        '',
        currentUser.token,
      );
    }
    
    if (!itemDetailSaga && !loadChildId) {
      yield put(loadCommunicationSuccess(false));
    } else {
      yield put(loadCommunicationSuccess(itemDetailSaga));
    }
  } catch (error) {
    yield put(loadCommunicationError(error));
  }
}

export function* updateCommunicationSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const localActiveChild = yield JSON.parse(
      localStorage.getItem('schoolinked_child'),
    );
    const prentID = currentUser?._id;
    const childID = localActiveChild?._id;
    const { itemDetail } = action;
    const ID = itemDetail?._ID;

    const newKey = 'nouvel';
    let updatedElemnet = false;
    if (!!ID && ID != newKey && !!childID) {
      updatedElemnet = yield requestWrapper(
        'PATCH',
        endpoint?.parent?.communications?.update(ID, childID),
        itemDetail,
        currentUser.token,
      );
    }

    if (!updatedElemnet) {
      yield put(updateCommunicationSuccess(false));
    } else {
      yield put(updateCommunicationSuccess(updatedElemnet));
    }
  } catch (err) {
    yield put(updateCommunicationError(true));
  }
}

// Individual exports for testing
export default function* communicationDetailMobileSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_COMMUNICATION, loadCommunicationSaga);
  yield takeLatest(UPDATE_COMMUNICATION, updateCommunicationSaga);
}
